import { createBrowserRouter, Navigate } from 'react-router-dom'

import { PATH_AFTER_LOGIN } from '../config-global'
import {
  BisnessUpdateDetailsPageLazy,
  BlogsPageLazy,
  BrandingLazy,
  ComingSoon,
  ConversationsLazy,
  DashboardPage,
  EventPicturesLazy,
  ExpenseLazy,
  FacilitiesLazy,
  GivesBackDetailsPageLazy,
  HeaderWrapper,
  HelpDeskLazy,
  HilabsGotTalentLazy,
  HilabsTalksLazy,
  HolidayLazy,
  LastMonthLazy,
  LifeAtHiLabsLazy,
  LifeCanvasDetailsPageLazy,
  LifeCanvasLazy,
  LoginPage,
  MASTERPAGE,
  MemoryLaneLazy,
  MyPathToHiLabsLazy,
  NewsDetailsPage,
  NewsPageLazy,
  NewToHiLabsLazy,
  PayrollLazy,
  RecipesDetailsPageLazy,
  RecipesPageLazy,
  RegisterPage,
  SpotLigthPageLazy,
  TalentAcquisitionLazy,
  Timesheets,
  TravelDetailsPageLazy,
  TravelLazy,
  WomenInHiLabsPageLazy,
  AuthGuard,
  DashboardLayout,
  DepartmentsLazy,
  ProductsLazy,
  HippaCompliance,
} from './elements'
import { PATH_AUTH, ROOTS_DASHBOARD } from './paths'
import { CheckToeknExpiry, isTestPassed, versionControl } from '../constant/auth'
import TestGuard from '../features/auth/guard/test-guard'
import AuthLayout from '../layouts/Auth'

export default function Routes() {
  const _ = versionControl()
  const isLogedIn = !CheckToeknExpiry()
  const rootPath = isTestPassed() ? '/dashboard/app' : '/hipaa-compliance'
  const path = isLogedIn ? rootPath : '/auth/login'
  return createBrowserRouter([
    {
      path: '/',
      element: <Navigate to={path} replace />,
      index: true,
    },
    {
      path: 'auth',
      element: <AuthLayout />,
      children: [
        { element: <Navigate to={path} replace />, index: true },
        {
          path: 'login',
          element: <LoginPage />,
        },
        {
          path: 'register',
          element: <RegisterPage />,
        },
      ],
    },
    {
      path: 'hipaa-compliance',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [{ path: '', element: <HippaCompliance /> }],
    },
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <TestGuard>
            <DashboardLayout />
          </TestGuard>
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <DashboardPage /> },
        { path: 'timesheet', element: <Timesheets /> },
        { path: 'helpdesk', element: <HelpDeskLazy /> },
        { path: 'branding', element: <BrandingLazy /> },
        { path: 'holiday', element: <HolidayLazy /> },
        { path: 'new-to-hilabs', element: <NewToHiLabsLazy /> },
        { path: 'travel', element: <TravelLazy /> },
        { path: 'talent-acquisition', element: <TalentAcquisitionLazy /> },
        { path: 'expense', element: <ExpenseLazy /> },
        { path: 'payroll', element: <PayrollLazy /> },
        { path: 'facilities', element: <FacilitiesLazy /> },
        { path: 'memory-lane', element: <MemoryLaneLazy /> },
        { path: 'all-event-pictures', element: <EventPicturesLazy /> },
        { path: 'recipes', element: <RecipesPageLazy />, excat: true },
        { path: 'recipes/:id', element: <RecipesDetailsPageLazy /> },
        { path: 'blogs', element: <BlogsPageLazy /> },
        { path: 'news', element: <NewsPageLazy /> },
        { path: 'news/:id', element: <NewsDetailsPage /> },
        { path: 'spotlight/:spotlightId', element: <SpotLigthPageLazy /> },
        { path: 'last-month', element: <LastMonthLazy /> },
        { path: 'last-month/life-canvas', element: <LifeCanvasLazy /> },
        {
          path: 'last-month/life-canvas/:canvasId',
          element: <LifeCanvasDetailsPageLazy />,
        },
        {
          path: 'conversations',
          element: <ConversationsLazy />,
        },
        {
          path: 'travel-story/:travelStoryId',
          element: <TravelDetailsPageLazy />,
        },
        { path: 'business-updates', element: <BisnessUpdateDetailsPageLazy /> },
        { path: 'hilabs-talks', element: <HilabsTalksLazy /> },
        {
          path: 'life-at-hilabs',
          element: <LifeAtHiLabsLazy />,
        },
        {
          path: 'life-at-hilabs/gives-back/:givesBackId',
          element: <GivesBackDetailsPageLazy />,
        },
        {
          path: 'life-at-hilabs/hilabs-gotTalent',
          element: <HilabsGotTalentLazy />,
        },
        {
          path: 'life-at-hilabs/women-in-hilabs/:womenInHiLabsId',
          element: <WomenInHiLabsPageLazy />,
        },
        {
          path: 'life-at-hilabs/my-path-to-hilabs/:myPathId',
          element: <MyPathToHiLabsLazy />,
        },
        {
          path: 'departments',
          element: <DepartmentsLazy />,
        },
        {
          path: 'departments/:departmentName',
          element: <DepartmentsLazy />,
        },
        {
          path: 'products',
          element: <ProductsLazy />,
        },
        {
          path: 'products/:productName',
          element: <ProductsLazy />,
        },
      ],
    },
    {
      path: 'page/:PAGENAME',
      element: (
        <AuthGuard>
          <TestGuard>
            <HeaderWrapper>
              <MASTERPAGE />
            </HeaderWrapper>
          </TestGuard>
        </AuthGuard>
      ),
      children: [],
    },
    {
      path: '/coming-soon',
      element: (
        <AuthGuard>
          <HeaderWrapper>
            <ComingSoon />
          </HeaderWrapper>
        </AuthGuard>
      ),
    },
    {
      path: '*',
      element: <Navigate to={`${ROOTS_DASHBOARD}`} />,
    },
  ])
}

export const ROUTE_PATH = {
  home: `${ROOTS_DASHBOARD}/app`,
  memoryLane: `${ROOTS_DASHBOARD}/memory-lane`,
  recipes: `${ROOTS_DASHBOARD}/recipes`,
  blogs: `${ROOTS_DASHBOARD}/blogs`,
  news: `${ROOTS_DASHBOARD}/news`,
  travelStory: `${ROOTS_DASHBOARD}/travel-story`,
  businessUpdates: `${ROOTS_DASHBOARD}/business-updates`,
  conversations: `${ROOTS_DASHBOARD}/conversations`,
  lastMonth: `${ROOTS_DASHBOARD}/last-month`,
  lifecanvas: `${ROOTS_DASHBOARD}/last-month/life-canvas`,
  hilabsTalk: `${ROOTS_DASHBOARD}/hilabs-talks`,
  comingSoon: '/coming-soon',
  login: PATH_AUTH.login,
  gavesBack: `${ROOTS_DASHBOARD}/life-at-hilabs/gives-back/`,
  hilabsGotTalent: `${ROOTS_DASHBOARD}/life-at-hilabs/hilabs-gotTalent/`,
  womenInHiLabs: `${ROOTS_DASHBOARD}/life-at-hilabs/women-in-hilabs/`,
  myPath: `${ROOTS_DASHBOARD}/life-at-hilabs/my-path-to-hilabs/`,
}
